import React, { FC, ButtonHTMLAttributes, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { t } from 'utils';
import { Button, Variant } from 'components/ui';
import { DeveloperAppVerb } from '../../modules/userApps/AppSettings/constants';
import styles from './SubmitAppButton.module.scss';
import { changeDeveloperAppStatus } from 'modules/userApps/store/actions/index';
import { getApp } from 'modules/userApps/store/actions';
import { useDispatchRequest } from '@redux-requests/react';

export enum AppStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
  APPROVED = 'APPROVED',
  PUBLISHED = 'PUBLISHED',
  BLOCKED = 'BLOCKED',
}

export interface ISubmitButtonFields {
  buttonText: string;
  variant?: Variant;
  icon?: string;
}

export interface ISubmitButton {
  [key: string]: ISubmitButtonFields;
}

export const submitButton: ISubmitButton = {
  [AppStatus.DRAFT]: {
    icon: 'upload',
    variant: 'ghost',
    buttonText: 'app.preview.settings.appAction.buttonSubmit',
  },
  [AppStatus.APPROVED]: {
    icon: 'rocket',
    variant: 'primary',
    buttonText: 'app.preview.settings.appAction.buttonPublish',
  },
  [AppStatus.DECLINED]: {
    icon: 'upload',
    variant: 'ghost',
    buttonText: 'app.preview.settings.appAction.buttonSubmit',
  },
};

export interface ISubmitAppButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  status: AppStatus;
  id: string;
}

const SubmitAppButton: FC<ISubmitAppButton> = (props) => {
  const { status, className, id } = props;
  const dispatchRequest = useDispatchRequest();
  const rootClassName = classNames(styles.root, className);
  const submitButtonData = useMemo<ISubmitButtonFields>(() => submitButton[status], [status]);

  const handleSubmitStatusChange = useCallback(async () => {
    let action;
    switch (status) {
      case AppStatus.DRAFT: {
        action = DeveloperAppVerb.REQUEST_APPROVAL;
        break;
      }
      case AppStatus.DECLINED: {
        action = DeveloperAppVerb.REQUEST_APPROVAL;
        break;
      }
      case AppStatus.APPROVED: {
        action = DeveloperAppVerb.PUBLISH;
        break;
      }
    }
    if (!status || !action) return;
    try {
      const { data: requestStatus } = await dispatchRequest(changeDeveloperAppStatus(id, action));
      if (requestStatus) await dispatchRequest(getApp(id));
    } catch (err) {
      console.error(err);
    }
  }, [dispatchRequest, id, status]);

  if (!submitButtonData) {
    return null;
  }
  return (
    <Button
      className={rootClassName}
      icon={submitButtonData.icon}
      iconPrefix='fal'
      variant={submitButtonData.variant}
      inline
      onClick={handleSubmitStatusChange}
    >
      {t(submitButtonData.buttonText)}
    </Button>
  );
};

export default SubmitAppButton;
